import { SYSTEM_VARIABLE } from "@/modules/Application/enuns/Environment";

const TERMINAL_KEY = "balanca_terminal_web_uuid";
const ACCESS_KEY = "balanca_local_access_token";

function uuid() {
  if (window.crypto && typeof window.crypto.randomUUID === "function") {
    return window.crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0;
    const value = char === "x" ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}

function getOrCreate(key) {
  let value = window.localStorage.getItem(key);
  if (!value) {
    value = uuid();
    window.localStorage.setItem(key, value);
  }
  return value;
}

export default {
  terminalUuid() {
    return getOrCreate(TERMINAL_KEY);
  },

  localAccessToken() {
    return getOrCreate(ACCESS_KEY);
  },

  pairingUrl(codigo) {
    const params = new URLSearchParams({
      api: String(SYSTEM_VARIABLE.BASE_URL_API || "").replace(/\/$/, ""),
      origin: window.location.origin,
      terminal: this.terminalUuid(),
      local_token: this.localAccessToken(),
      codigo,
    });
    return `balanca-pdv://parear?${params.toString()}`;
  },

  abrirAgente(codigo) {
    window.location.href = this.pairingUrl(codigo);
  },
};
